import Axios from "axios";
import { getTodaySqlFormat } from "../../../helpers/functions";
import { apiATC } from "../../../config";
import store from "../../..";
import { getAtelier, getListeAtelier, getListeOfSerti, getListeBoiteOr } from "../../../actions";

/* eslint-disable eqeqeq */
/**
 * Ajouter un nouveau mouvement joaillier
 * Logique:
 * - Si combo [id_joaillier + n_sachet] n'existe pas -> INSERT
 * - Si combo existe avec rendu=0 -> ERREUR (déjà en cours)
 * - Si combo existe avec rendu=1 -> INSERT (nouvelle ligne)
 */
export const ajouterJoaillier = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];

        // Récupérer la liste des ateliers - ATTENDRE que le state se mette à jour
        await store.dispatch(getListeAtelier());
        const state = store.getState();
        const listeOfsAtelier = state.generalData.listeAtelier;
        
        const axiosRequests = data.map(item => {
            // Vérification si la combinaison id_ouvrier et n_sachet existe AVEC rendu = 0
            const existingItemWithRenduZero = listeOfsAtelier.find(
                atelier => String(atelier.id_ouvrier) === String(item.id_joaillier) && 
                           String(atelier.n_sachet) === String(item.of) && 
                           (atelier.rendu === 0 || atelier.rendu == '0')
            );

            // Si la combo existe déjà EN COURS, rejeter avec erreur
            if (existingItemWithRenduZero) {
                const error = new Error('COMBO_ALREADY_IN_PROGRESS');
                error.existingItem = existingItemWithRenduZero;
                throw error;
            }
            
            const dataToSave = {
                table: 'ouvrier',
                date_envoi: getTodaySqlFormat(),
                date_retour: item.rendu === 1 ? getTodaySqlFormat() : '0000-00-00',
                poids_d: item.poids,
                poids_r: item.poidsR || 0,
                id_ouvrier: item.id_joaillier,
                n_sachet: item.of,
                temps: item.temps || 0,
                rendu: item.rendu || 0,
                id_ligne: item.id_ligne || null,
            };
            
            // Ajouter une nouvelle ligne
            modifierStatut(item.of, 200);
            return Axios.post(`${apiATC}/general.php?action=ajouter`, dataToSave)
        });

        try {
            const responses = await Promise.all(axiosRequests);
            // Recharger après TOUS les ajouts
            await store.dispatch(getListeAtelier());
            store.dispatch(getAtelier());
            return responses;
        } catch (error) {
            if (error.message === 'COMBO_ALREADY_IN_PROGRESS') {
                console.warn("La combinaison est déjà en cours :", error.existingItem);
                throw error; // Propager l'erreur pour être gérée dans le composant
            }
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error;
        }
    } catch (error) {
        if (error.message === 'COMBO_ALREADY_IN_PROGRESS') {
            throw error;
        }
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error;
    }
};

export const modifierJoaillier = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];
        const axiosRequests = data.map(item => {
            const toNumber = (value, fallback = 0) => {
                const parsed = Number(value);
                return Number.isFinite(parsed) ? parsed : fallback;
            };

            const idLigne = item.id_ligne ?? item.id;
            const ofValue = item.of ?? item.n_sachet;
            const poidsDepart = toNumber(item.poids ?? item.poids_d ?? 0);
            const poidsRetour = toNumber(item.poidsR ?? item.poids_r ?? 0);
            const tempsValue = toNumber(item.temps ?? 0);
            const renduValue = item.rendu != null ? toNumber(item.rendu, 1) : 1;

            if (!idLigne) {
                console.error('modifierJoaillier: id_ligne manquant', item);
                throw new Error('ID_LIGNE_MISSING');
            }

            const dataToSave = {
                table: 'ouvrier',
                primaryKey: 'id_ligne',
                id: idLigne,
                date_retour: item.date_retour || getTodaySqlFormat(),
                poids_r: poidsRetour,
                poids_d: poidsDepart,
                temps: tempsValue,
                rendu: renduValue,
            };

            if (ofValue) {
                modifierStatut(ofValue, 200);
            }
            return Axios.post(`${apiATC}/general.php?action=modifier`, dataToSave)
        });

        // Retourne la promesse générée par Promise.all()
        try {
            const responses = await Promise.all(axiosRequests);
            store.dispatch(getListeAtelier());
            store.dispatch(getAtelier());
            return responses;
        } catch (error) {
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error; // Propage l'erreur pour la gérer dans le dossier parent
        }
    } catch (error) {
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error; // Propage l'erreur pour la gérer dans le dossier parent
    }
};

export const supprimerJoaillier = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];
        const axiosRequests = data.map(item => {
            const dataToSave = {
                table: 'ouvrier',
                primaryKey: 'id_ligne',
                id: item.id_ligne,
            };

            return Axios.post(`${apiATC}/general.php?action=supprimer`, dataToSave);
        });

        // Retourne la promesse générée par Promise.all()
        try {
            const responses = await Promise.all(axiosRequests);
            store.dispatch(getListeAtelier());
            store.dispatch(getAtelier());
            return responses;
        } catch (error) {
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error; // Propage l'erreur pour la gérer dans le dossier parent
        }
    } catch (error) {
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error; // Propage l'erreur pour la gérer dans le dossier parent
    }
};

export const ajouterSertisseur = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];

        // Récupérer la liste des ateliers - ATTENDRE que le state se mette à jour
        await store.dispatch(getListeOfSerti());
        const state = store.getState();
        const listeSerti = state.generalData.listeOfSerti;
        
        const axiosRequests = data.map(item => {
            // Vérification si la combinaison of_serto et id_serto existe AVEC rendu_serti = 0
            const existingItemWithRenduZero = listeSerti.find(
                serti => String(serti.of_serto) === String(item.of) && 
                         String(serti.id_serto) === String(item.id_sertisseur) && 
                         (serti.rendu_serti === 0 || serti.rendu_serti == '0')
            );

            // Si la combo existe déjà EN COURS, rejeter avec erreur
            if (existingItemWithRenduZero) {
                const error = new Error('COMBO_ALREADY_IN_PROGRESS');
                error.existingItem = existingItemWithRenduZero;
                throw error;
            }
            
            const dataToSave = {
                table: 'serti',
                date_e: getTodaySqlFormat(),
                date_r: item.rendu_serti === 1 ? getTodaySqlFormat() : '0000-00-00',
                pds_d: item.poids,
                pds_r: item.poidsR || 0,
                id_serto: item.id_sertisseur,
                of_serto: item.of,
                prix: item.prix || 0,
                rendu_serti: item.rendu_serti || 0,
                id_sert: item.id_sert || null,
            };
            
            // Ajouter une nouvelle ligne
            modifierStatut(item.of, 200);
            return Axios.post(`${apiATC}/general.php?action=ajouter`, dataToSave)
        });
        try {
            const responses = await Promise.all(axiosRequests);
            // Recharger après TOUS les ajouts
            await store.dispatch(getListeOfSerti());
            return responses;
        } catch (error) {
            if (error.message === 'COMBO_ALREADY_IN_PROGRESS') {
                console.warn("La combinaison est déjà en cours :", error.existingItem);
                throw error; // Propager l'erreur pour être gérée dans le composant
            }
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error;
        }
    } catch (error) {
        if (error.message === 'COMBO_ALREADY_IN_PROGRESS') {
            throw error;
        }
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error;
    }
};

export const modifierSertisseur = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];
        const axiosRequests = data.map(item => {
            const toNumber = (value, fallback = 0) => {
                const parsed = Number(value);
                return Number.isFinite(parsed) ? parsed : fallback;
            };

            const idSert = item.id_sert ?? item.id ?? item.id_serto;
            const ofValue = item.of ?? item.of_serto;
            const poidsDepart = toNumber(item.poids ?? item.pds_d ?? 0);
            const poidsRetour = toNumber(item.poidsR ?? item.pds_r ?? 0);
            const prixValue = toNumber(item.prix ?? 0);
            const dateRetour = item.date_retour ?? getTodaySqlFormat();
            const renduSerti = item.rendu_serti != null ? String(item.rendu_serti) : "1";

            if (!idSert) {
                console.error('modifierSertisseur: id_sert manquant', item);
                throw new Error('ID_SERT_MISSING');
            }

            const dataToSave = {
                table: 'serti',
                primaryKey: 'id_sert',
                id: idSert,
                date_r: dateRetour,
                pds_r: poidsRetour,
                pds_d: poidsDepart,
                prix: prixValue,
                rendu_serti: renduSerti,

            };
            if (ofValue) {
                modifierStatut(ofValue, 500);
            }
            return Axios.post(`${apiATC}/general.php?action=modifier`, dataToSave)
        });

        // Retourne la promesse générée par Promise.all()
        try {
            const responses = await Promise.all(axiosRequests);
            await store.dispatch(getListeOfSerti())
            return responses;
        } catch (error) {
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error; // Propage l'erreur pour la gérer dans le dossier parent
        }
    } catch (error) {
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error; // Propage l'erreur pour la gérer dans le dossier parent
    }
};

export const supprimerSertisseur = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];
        const axiosRequests = data.map(item => {
            const dataToSave = {
                table: 'serti',
                primaryKey: 'id_sert',
                id: item.id_sert,
            };

            return Axios.post(`${apiATC}/general.php?action=supprimer`, dataToSave);
        });

        // Retourne la promesse générée par Promise.all()
        try {
            const responses = await Promise.all(axiosRequests);
            await store.dispatch(getListeOfSerti())
            return responses;
        } catch (error) {
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error; // Propage l'erreur pour la gérer dans le dossier parent
        }
    } catch (error) {
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error; // Propage l'erreur pour la gérer dans le dossier parent
    }
};
export const ajouterBoiteOr = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];
        const axiosRequests = data.map(item => {
            const dataToSave = {
                table: 'boite_or',
                id_ouvr: item.id_joaillier,
                done_ouvr: item.poidsD,
                rendu_ouvr: item.poidsR,
                date: getTodaySqlFormat(),
            };
            return Axios.post(`${apiATC}/general.php?action=ajouter`, dataToSave)
        });
        // Retourne la promesse générée par Promise.all()
        try {
            const responses = await Promise.all(axiosRequests);
            store.dispatch(getListeBoiteOr());
            return responses;
        } catch (error) {
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error; // Propage l'erreur pour la gérer dans le dossier parent
        }
    } catch (error) {
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error; // Propage l'erreur pour la gérer dans le dossier parent
    }
};
export const modifierBoiteOr = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];
        const axiosRequests = data.map(item => {
            const dataToSave = {
                table: 'boite_or',
                primaryKey: 'id_boite',
                id: item.id_boite,
                done_ouvr: item.done_ouvr,
                rendu_ouvr: item.rendu_ouvr,

            };
            return Axios.post(`${apiATC}/general.php?action=modifier`, dataToSave)
        });

        // Retourne la promesse générée par Promise.all()
        try {
            const responses = await Promise.all(axiosRequests);
            store.dispatch(getListeBoiteOr());
            return responses;
        } catch (error) {
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error; // Propage l'erreur pour la gérer dans le dossier parent
        }
    } catch (error) {
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error; // Propage l'erreur pour la gérer dans le dossier parent
    }
};

export const supprimerBoiteOr = async (forms) => {
    try {
        const data = Array.isArray(forms) ? forms : [forms];
        const axiosRequests = data.map(item => {
            const dataToSave = {
                table: 'boite_or',
                primaryKey: 'id_boite',
                id: item.id_boite,
            };
            return Axios.post(`${apiATC}/general.php?action=supprimer`, dataToSave);
        });

        // Retourne la promesse générée par Promise.all()
        try {
            const responses = await Promise.all(axiosRequests);
            store.dispatch(getListeBoiteOr());
            return responses;
        } catch (error) {
            console.log("Une erreur s'est produite lors de l'exécution des requêtes :", error);
            throw error; // Propage l'erreur pour la gérer dans le dossier parent
        }
    } catch (error) {
        console.log("Une erreur s'est produite lors du traitement des données :", error);
        throw error; // Propage l'erreur pour la gérer dans le dossier parent
    }
};

const modifierStatut = (of, statut) => {
    // Vérification des paramètres
    if (!of || !statut) {
        console.error('Erreur: of ou statut manquant.');
        return;
    }

    Axios.get(`${apiATC}/of/functions.php`, {
        params: {
            action: 'modifierStatut',
            of,
            statut
        }
    })
    .then(response => {
        // Optionnel: traiter la réponse si besoin
    })
    .catch(error => {
        console.error('Erreur lors de la mise à jour du statut:', error);
    });
};
